// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1WV9W","head":"ProcedureTableInfo_head__15LM3"};